
import API from '../api';
import eventBus from './eventBus';
export function productPriceFormat (row, column, cellValue) {
  if (cellValue) {
    let value = Number(cellValue).toFixed(2);
    let intPart = Math.trunc(value);
    let intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
    let value2Array = value.toString().split('.');
    if (value2Array.length === 2) {
      let floatPart = value2Array[1]; // 拿到小数部分
      intPartFormat = intPartFormat + '.' + floatPart;
      return intPartFormat;
    } else {
      return intPartFormat;
    }
  } else {
    return cellValue;
  }
}
export function productPriceFormat2 (row, column, cellValue) {
  if (cellValue) {
    let value = Number(cellValue).toFixed(2);
    let intPart = Math.trunc(value);
    return intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
  } else {
    return cellValue;
  }
};
export function productPriceFormat3 (row, column, cellValue) {
  if (row.isRiil && row.retailPriceFloatingRate > 0) {
    if (row.retailPriceFloatingRate > 0) {
      return 'list*' + row.retailPriceFloatingRate;
    }
  }
  if (row.lineId === 25) {
    if (row.productPrice < 1 || row.productPrice === null) {
      return row.sprPriceRatio;
    }
  }
  if (cellValue) {
    let value = Number(cellValue).toFixed(2);
    let intPart = Math.trunc(value);
    let intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
    let value2Array = value.toString().split('.');
    if (value2Array.length === 2) {
      let floatPart = value2Array[1]; // 拿到小数部分
      intPartFormat = intPartFormat + '.' + floatPart;
      return intPartFormat;
    } else {
      return intPartFormat;
    }
  } else {
    return cellValue;
  }
};
export function changeStyle ({ row, rowIndex }) {
  if (row.purchaseQuantity && row.purchaseQuantity > 0) {
    return {
      // backgroundColor: '#aadbe9',
      backgroundColor: '#ffff',
      // borderLeft: '2px solid #003791'
    };
  } else {
    if (row.productInitListVO && row.productInitListVO.purchaseQuantity && row.productInitListVO.purchaseQuantity > 0) {
      return {
        backgroundColor: '#aadbe9',
        // borderLeft: '2px solid #003791'
      };
    }
  }
}

export function changeColStyle ({ row, rowIndex }) {
  if (row.purchaseQuantity && row.purchaseQuantity > 0) {
    return {
      backgroundColor: '#aadbe9'
      // borderLeft: '2px solid #003791'
    };
  }
}

export function getProductListParam (data) {
  let parame = {
    productInitVO: {},
    productInitListVOS: [],
    addProductIndexList: []
  };
  data.forEach((item, index) => {
    if (item.nodeLevel && item.nodeLevel === 1) {
      if (item.productInitListVO.purchaseQuantity > 0) {
        parame.productInitVO = item.productInitListVO;
        parame.productInitListVOS.push(parame.productInitVO);
      }
    }
    if (item.children && item.children != null) {
      item.children.forEach((item2, index) => {
        if (item2.nodeLevel && item2.nodeLevel === 2) {
          // console.log('item2=', item2.children);
          if (item2.children && item2.children !== null) {
            item2.children.forEach((item3, index) => {
              if (item3.nodeLevel && item3.nodeLevel === 2) {
                if (item3.children && item3.children !== null) {
                  item3.children.forEach((item4, index) => {
                    if (item4.productInitListVO && item4.productInitListVO.purchaseQuantity > 0) {
                      parame.productInitListVOS.push(item4.productInitListVO);
                    } else if (item4.productInitListVO && item4.productInitListVO.itemId !== null && item4.productInitListVO.purchaseQuantity === 0) {
                      parame.productInitListVOS.push(item4.productInitListVO);
                    }
                  });
                }
              } else {
                if (item3.productInitListVO && item3.productInitListVO.purchaseQuantity > 0) {
                  parame.productInitListVOS.push(item3.productInitListVO);
                } else if (item3.productInitListVO && item3.productInitListVO.itemId !== null && item3.productInitListVO.purchaseQuantity === 0) {
                  parame.productInitListVOS.push(item3.productInitListVO);
                }
              }
            });
          }
        }
      });
    }
  });
  return parame;
}

export function getGroupType (isService) {
  let groupType = 1;
  if (isService) {
    groupType = 2;
  }
  return groupType;
}

export const ProductItem = {
  data () {
    return {
      shareMessageDto: {
        lowerShelf: '',
        spdcProduct: '',
        orderInfo: '',
        supplyInfo: [],
        supplyList:[],
        delistingProductList: [],
        deliveryPeriod: '',
        maxDeliveryPeriodProductList: [],
        supplyInfoVOList: [],
        promptInformation: '',
        matchingFlg: false
      },
      dialogFormVisible: false
    };
  },
  methods: {
    // getLowershelf (projectId) {
    //   API.getLowershelf({ params: { 'projectId': projectId } }).then((res) => {
    //     let json = res.data;
    //     this.shareMessageDto = json.data;
    //     if (this.shareMessageDto.lowerShelf !== '' && this.shareMessageDto.lowerShelf !== null ||
    //       this.shareMessageDto.spdcProduct !== '' && this.shareMessageDto.spdcProduct !== null ||
    //       this.shareMessageDto.orderInfo !== '' && this.shareMessageDto.orderInfo !== null ||
    //       this.shareMessageDto.supplyInfo !== null && this.shareMessageDto.supplyInfo.length > 0 ||
    //       this.shareMessageDto.deliveryPeriod !== '' && this.shareMessageDto.deliveryPeriod !== null ||
    //       this.shareMessageDto.replaceParamDTOS !== null && this.shareMessageDto.replaceParamDTOS !== '' ||
    //       this.shareMessageDto.supplyInfoVOList !== null && this.shareMessageDto.supplyInfoVOList.length > 0 ||
    //       this.shareMessageDto.matchingFlg
    //     ) {
    //       this.dialogFormVisible = true;
    //     } else {
    //       this.operateParent();
    //     }
    //   }).catch(() => {
    //   });
    // },
    getLowershelf(projectId){
      API.getLowershelf({params: {"projectId": projectId}}).then((res) => {
        let json = res.data;
        this.shareMessageDto=json.data;
        if(this.shareMessageDto.lowerShelf != '' && this.shareMessageDto.lowerShelf != null
          || this.shareMessageDto.spdcProduct != '' && this.shareMessageDto.spdcProduct != null
          ||this.shareMessageDto.orderInfo != '' && this.shareMessageDto.orderInfo != null
          ||this.shareMessageDto.supplyInfo != null && this.shareMessageDto.supplyInfo.length>0
          ||this.shareMessageDto.deliveryPeriod != '' && this.shareMessageDto.deliveryPeriod != null
          ||this.shareMessageDto.replaceParamDTOS != null && this.shareMessageDto.replaceParamDTOS != ''
          ||this.shareMessageDto.supplyInfoVOList != null && this.shareMessageDto.supplyInfoVOList.length>0
          ||this.shareMessageDto.matchingFlg
        ){
          this.dialogFormVisible=true;
        }else {
          this.operateParent();
        }
      });
    },
    operateParent () {
      eventBus.$emit('fatherMethods');
    }
  }
};
